import { createFileRoute } from '@tanstack/react-router';
import { lazy } from 'react';

const Onboarding = lazy(() => import('@/pages/Onboarding'));

export const Route = createFileRoute('/app/onboarding')({
  component: Onboarding,
});
